import { createGlobalStyle } from 'styled-components';

const SIZES = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

export const BREAKPOINTS = {
  sm: `@media (min-width: ${SIZES.sm}px)`,
  md: `@media (min-width: ${SIZES.md}px)`,
  lg: `@media (min-width: ${SIZES.lg}px)`,
  xl: `@media (min-width: ${SIZES.xl}px)`
}

export default createGlobalStyle`
  /* BLOCO BÁSICO PARA CONSTRUÇÃO DA APP */
  ldiv {
    animation: 0s none;
    backface-visibility: visible;
    background: none;
    border: 0;
    box-shadow: none;
    box-sizing: border-box;
    bottom: auto;
    caption-side: top;
    clear: none;
    clip: auto;
    cursor: inherit;
    display: block;
    direction: ltr;
    flex: none;
    height: auto;
    hyphens: manual;
    image-rendering: auto;
    justify-content: flex-start;
    left: auto;
    letter-spacing: normal;
    line-height: normal;
    margin: 0;
    max-height: none;
    max-width: none;
    min-height: 0;
    min-width: 0;
    object-fit: fill;
    opacity: 1;
    order: 1;
    orphans: 2;
    outline: 0 none;
    overflow: visible;
    padding: 0;
    perspective: none;
    position: static;
    resize: none;
    right: auto;
    text-align: left;
    text-decoration: none;
    text-indent: 0;
    text-overflow: clip;
    text-shadow: none;
    text-transform: none;
    top: auto;
    transform: none;
    transition: all 0s ease 0s;
    unicode-bidi: normal;
    user-select: none;
    vertical-align: baseline;
    white-space: normal;
    width: auto;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    z-index: auto;
    zoom: normal;
    filter: none !important;
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
  }

  #✡︎ {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-size: 16px;
    line-height: 1.4;
    text-align: left;
  }

  #✡︎, #✡︎ * {
    box-sizing: border-box;
  }
  
  #✡︎ {
    .container {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    
      ${BREAKPOINTS.sm} {
        max-width: 540px;
      }
    
      ${BREAKPOINTS.md} {
        max-width: 720px;
      }
    
      ${BREAKPOINTS.lg} {
        max-width: 960px;
      }
    
      ${BREAKPOINTS.xl} {
        max-width: 1140px;
      }
    }

    .row {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
    }

    .col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
      position: relative;
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
    }

    .col {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
    
    .col-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }

    ${BREAKPOINTS.lg} {
      .col-lg-8 {
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
      }

      .col-lg-7 {
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
      }

      .col-lg-5 {
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
      }

      .col-lg-4 {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
      }

      .mb-lg-0, .my-lg-0 {
        margin-bottom: 0!important;
      }
    }
  }
`;
